import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import withRouter from "components/_Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/images/schor-logo.png";
import logoLightPng from "../../assets/images/schor-logo.png";
import logoFrenchPng from "../../assets/images/french-logo.png";
import dashLogo from "../../assets/images/sidebar-logo.png"
import SidebarParticipant from "./SidebarParticipant";
import checkType from "helpers/jwt-token-access/checkType"
import SidebarRater from "./SidebarRater";
import { lowerCase } from "lodash";

const Sidebar = props => {
  const { authType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
    authType: state?.CheckAuthType?.authType,
  }));
  const [typePanel, setTypePanel] = useState();
  const [selectedLang, setSelectedLang] = useState("");
  useEffect(() => {
    setTypePanel(checkType())
  }, [])

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(lowerCase(currentLanguage));
  }, [])
  
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to={typePanel && typePanel == 'rater'  ? "/save-servey" :"/dashboard"} className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
          </Link>

          <Link to={typePanel && typePanel == 'rater'  ? "/save-servey" :"/dashboard"} className="logo logo-light w-100 text-start ps-0 pt-0">
            <span className="logo-lg logo-big-dash logo-dashboard d-inline-block w-100 h-100">
              <img 
              // src={logoLightPng} 
               src={selectedLang == "fr" ? logoFrenchPng :   logoLightPng}
              alt="" 
              />
            </span>
            <span className="logo-lg logo-dashboard small-dash-logo d-inline-block w-100 h-100">
              <img src={dashLogo} alt="" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {
            typePanel && typePanel == 'admin'
            && <SidebarContent />
          }
          {
            typePanel && typePanel == 'participant'
            && <SidebarParticipant />
          }
          {
            typePanel && typePanel == 'rater'
            && <SidebarRater />
          }
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
